import { apiClient } from '../lib/apiClient';

/** A Reef Guard finding (#1820) — a trend / rate-of-change rule (or a stale test, #1823) that fired for one aquarium. */
export interface ReefGuardFinding {
  readonly id: string;
  readonly aquariumId: string;
  readonly aquariumName: string;
  readonly ruleId: string;
  readonly parameterId: string;
  readonly severity: 'hint' | 'warning' | 'critical';
  readonly confidence: 'high' | 'medium' | 'low';
  readonly direction: 'rise' | 'drop' | 'none';
  readonly variant: string;
  readonly details: {
    readonly from: number;
    readonly to: number;
    readonly delta: number;
    readonly hours: number;
    readonly perDay: number;
    readonly threshold: number;
    readonly readings: number;
    readonly windowStart: string;
    readonly windowEnd: string;
  };
  readonly source: string;
  readonly firstDetectedAt: string;
  readonly lastDetectedAt: string;
  readonly acknowledged: boolean;
}

export const REEF_GUARD_FINDINGS_KEY = ['reefGuardFindings'] as const;

/** GET /api/v1/alerts/findings — re-evaluates the user's aquariums and lists open findings. */
export async function listReefGuardFindings(): Promise<ReefGuardFinding[]> {
  const response = await apiClient.get<{ data: ReefGuardFinding[] }>('/api/v1/alerts/findings');
  // Only well-formed findings are rendered (a malformed row must not break the Alerts page).
  return Array.isArray(response?.data)
    ? response.data.filter((f) => f !== null && typeof f === 'object' && typeof f.details === 'object' && f.details !== null)
    : [];
}

export async function acknowledgeReefGuardFinding(id: string): Promise<void> {
  await apiClient.post(`/api/v1/alerts/findings/${id}/acknowledge`, {});
}

export async function snoozeReefGuardFinding(id: string, hours: number): Promise<void> {
  await apiClient.post(`/api/v1/alerts/findings/${id}/snooze`, { hours });
}
